<template>
    <vue-html2pdf
      :show-layout="false"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      :filename="'Resume ' + candidate.full_name"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="letter"
      :html-to-pdf-options="{
        margin: 10,
      }"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      ref="html2Pdf"
      >

    <section slot="pdf-content">
      <div class="resume">
          <h1>{{candidate.full_name}} {{candidate.jp_first_name ? '('+jp_full_name+')' : ''}}</h1>
          <h3>{{candidate.present_work}}</h3>
          <!-- <div class="socials">
              <div class="row">
                  <div class="item"><img src="github.png"/><a href="https://github.com/">https://github.com/{username}</a></div>
                  <div class="item"><img src="address-icon.png"/>Random Gallery 4, World, Universe</div>
              </div>
              <div class="row">
                  <div class="item"><img src="stackoverflow.png"/><a href="https://stackoverflow.com/">https://stackoverflow.com/story/{username}</a></div>
                  <div class="item"><img src="contact-icon.png"/>+00 0000 0000 0000 <b>@ :</b> random@fakeisfake.com</div>
              </div>
          </div> -->
          <div class="summary">
            {{candidate.summary}}
          </div>
          <div class="content">
            <div class="sidebar">
              <div class="block-title">SKILLS</div>
              <div class="margin10 items">
                <span class="item" v-for="skill in candidate.skills" :key="skill.id">
                  {{skill.name}}
                </span>
              </div>
            </div>
            <div class="block">
                <div class="block-title">EXPERIENCE</div>

                <table class="margin10 job1" v-for="experience in candidate.work_experiences" :key="experience.id">
                    <tr>
                        <td valign="top"><b>{{experience.start_month | capitalize}} {{experience.start_year}} - {{experience.present ? 'Present' : experience.end_month | capitalize}} {{experience.present ? '' : experience.end_year}}</b></td>
                    </tr>
                    <tr>
                        <td>
                            <div><b>{{experience.position}}</b></div>
                            <div>{{experience.company}}</div>
                        </td>
                    </tr>
                    <tr>
                      <td>
                        <pre style="white-space: pre-line;">{{experience.description}}</pre>
                      </td>
                    </tr>
                </table>

                <div class="margin20 block-title">EDUCATION</div>
                <table class="margin10" v-for="education in candidate.education_background" :key="education.id">
                    <tr>
                        <td valign="top" style="width: 100px;">{{education.start_year}} – {{education.end_year}}</td>
                        <td style="padding-left: 20px;">
                            <div><b>{{education.degree}}</b></div>
                            <div>{{education.school}}</div>
                        </td>
                    </tr>
                </table>
            </div>
          </div>
        </div>
    </section>
  </vue-html2pdf>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import FormMixin from '@mixins/form'

export default {
  mixins: [FormMixin],
  components: {VueHtml2pdf},
  data(){
    return {
      candidate:{}
    }
  },
  methods:{
    generateReport (uiid, type){
      let endpoint = 'application/getApplication'
      
      if(type == 'candidate'){
        endpoint = 'candidate/findCandidate'
      }

      this.toggleLoading()

      this.$store.dispatch(endpoint, {id:uiid}).then(res => {
        this.$refs.html2Pdf.generatePdf()
        this.candidate = res.data
        this.toggleLoading()
      })
    }
  },
  mounted(){
  }
}
</script>


<style lang="scss">
.vue-html2pdf .pdf-preview{
  min-width: unset !important;
}
@media screen and (max-width: 850px){
  .vue-html2pdf .pdf-preview{
    width: 90% !important;
    height: 100% !important;
    top:50px !important
  }
}
  .resume{
    a{
      color: #333333;
      text-decoration: none;
    }
    pre{
      font-family: "Nunito Sans", sans-serif;
    }
    h1{
        font-family: 'Noto Sans', sans-serif;
        font-size:28px;
        line-height: 28px;
        margin: 0;
        font-weight: 400;
    }
    h3{
        font-family: 'Ubuntu', sans-serif;
        font-size: 16px;
        line-height: 16px;
        margin: 4px 0;
        color: #666666;
    }
    div.socials {
        font-family: 'Nunito', sans-serif;
        font-size: 14px;
        border: 1px solid #666666;
        margin-top: 10px;
        border-left: 0px;
        border-right: 0px;
        padding: 5px 0px;
        color: #333333;
    }
    div.socials .row .item{
        position: relative;
        display: inline-block;
        line-height: 28px;
        min-width: 320px;
    }
    div.socials .row .item img{
        width: 24px;
        height: 24px;
        position: relative;
        top: 6px;
        margin-right: 10px;
    }
    /* div.summary{
      font-family: 'Open Sans', sans-serif;
      font-size: 14px;
      text-align: justify;
      margin-top: 10px;
      color: #1c1c1c;
    } */
    div.content {
      // word-wrap: break-word;
      // word-break: break-all;
      // white-space: normal;
      /* font-family: 'Open Sans', sans-serif; */
    }
    div.content .block{
      padding-right: 10px;
    }
    div.content .block .block-title, div.content .sidebar .block-title{
      font-weight: bold;
      font-size: 16px;
      border: 1px solid #666666;
      border-width: 0px 0px 1px 0px;
    }
    div.content .block table{
      white-space: normal;
      font-size: 14px;
      page-break-inside: avoid;
    }
    .margin10{
      margin-top: 10px;
    }
    .margin20{
      margin-top: 20px;
    }
    div.content .block table tr td ul, div.content .block table tr td ul li{
      margin: 0 0 0 0;
      padding: 0 0 0 0;
    }
    div.content .block table tr td ul li{
      line-height: 20px;
    }
    div.content .sidebar{
      //padding-left: 10px;
      margin-bottom: 10px;
      
    }
    div.content .sidebar .items{
      display: inline-block;
      font-size: 12px;
      width:700px
    }
    div.content .sidebar .item{
      display: inline-block;
      background:grey; 
      color:white; 
      margin:1px; 
      padding:1px 5px; 
      border-radius:5px;
    }
  }
  
</style>